// extracted by mini-css-extract-plugin
export default {"button":"l5O_CA","link":"vFJRxo"};